import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TranslateComponent } from './translate/translate.component';
import { LoginComponent } from './login/login.component';
import { VerticalComponent } from '../vertical/vertical.component';
import { VideoComponent } from './video/video.component';
import { VideologinComponent } from './video/videologin/videologin.component';
import { VideoGuard } from '../video.guard';
import { AuthGuard } from '../auth.guard';
import { TranslateGuard } from '../translate.guard';

const routes: Routes = [
  { path: 'translate', component: TranslateComponent, canActivate: [TranslateGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'vertical', component: VerticalComponent },
  { path: 'video', component: VideoComponent, canActivate: [VideoGuard] },
  { path: 'video/login', component: VideologinComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExtraRoutingModule {}
